import { URI } from '@/config/config'

export default async ({ rootState }, { query }) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    },
    body: JSON.stringify(query)
  }

  const userLoginInfoResult = await fetch(`${URI}vehicle/remove-exempt`, opts)
  const resultJson = await userLoginInfoResult.json()
  return resultJson.result.exemptList
}